import React from "react";
import PropTypes from "prop-types";

const WrappedCell = ({ renderedCellValue }) => (
  <div
    style={{
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      marginRight: "5px",
    }}
  >
    {renderedCellValue}
  </div>
);

WrappedCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
};

const columnConfig = () => {
  return [
    {
      header: "Client ID",
      id: "clientId",
      accessorKey: "clientId",
      size: 280,
      Cell: WrappedCell,
    },
    {
      header: "Workspaces",
      id: "workspaces",
      accessorKey: "clientMetadata.workspaces",
      size: 220,
      Cell: WrappedCell,
    },
    {
      header: "Description",
      id: "description",
      accessorKey: "description",
      size: 220,
      Cell: WrappedCell,
    },
    {
      header: "Read scopes",
      id: "readScopes",
      accessorKey: "clientMetadata.readScopes",
      size: 220,
      Cell: WrappedCell,
    },
    {
      header: "Write scopes",
      id: "writeScopes",
      accessorKey: "clientMetadata.writeScopes",
      size: 220,
      Cell: WrappedCell,
    },
    {
      header: "Expiry Date",
      id: "expiryDate",
      accessorKey: "clientMetadata.expiryDate",
      size: 120,
    },
    {
      header: "Actions",
      id: "actions",
      accessorKey: "actions",
      size: 200,
      enableColumnPinning: true,
      muiTableHeadCellProps: {
        style: {
          paddingLeft: "10px",
        },
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
};

export default columnConfig;
